import React from 'react';
import {
  Card,
  Header,
  Icon,
  Image,
  Popup,
  Segment,
} from 'semantic-ui-react';

import {
  CustomContainer,
  RequiresLogin,
} from '../../common';
import {
  USER_FANS_LIMIT,
} from '../../../constants';
import {
  UserLink,
} from '../../Links';
import {
  formatDatetime,
  getUserAvatar,
} from '../../Utils';

const DETAILS_MESSAGE = `
  選出經常回覆此ID 文章的前${USER_FANS_LIMIT}名用戶
`;

const STYLES = {
  QUESTION_ICON: {
    float: 'right' as const,
    cursor: 'pointer',
    color: '#7f8c8d',
  },
};

interface FansProps {
  authed: boolean;
  data: any[];
  isFetching: boolean;
  isMobile: boolean;
}

export default (props: FansProps) => {
  const {
    authed,
    data,
    isFetching,
    isMobile,
  } = props;

  const hasData = (Array.isArray(data) && data.length > 0);

  return (
    <CustomContainer>
      <Header as={isMobile ? 'h3' : 'h2'} attached="top">
        忠實粉絲
        <div
          style={STYLES.QUESTION_ICON}
        >
          <Popup
            trigger={<Icon name="question" size="small" />}
            content={DETAILS_MESSAGE}
            position="bottom right"
          />
        </div>
      </Header>
      <Segment attached loading={isFetching}>
        <RequiresLogin dimmed={!authed}>
          {
            hasData ? (
              <Card.Group>
                {
                  data
                    .map((user) => (
                      <Card
                        key={user.id}
                        centered
                      >
                        <Card.Content>
                          <Image
                            circular
                            floated="right"
                            size="mini"
                            src={getUserAvatar(user.id)}
                          />
                          <Card.Header>
                            <UserLink id={user.id}>
                              {user.id}
                            </UserLink>
                          </Card.Header>
                          <Card.Meta>
                            {user.nickname || '沒有綽號喔'}
                          </Card.Meta>
                          <Card.Description>
                            上次留下足跡
                            {formatDatetime(user.last_visit)}
                          </Card.Description>
                        </Card.Content>
                      </Card>
                    ))
                }
              </Card.Group>
            ) : (
              <p>無資料 (._.)</p>
            )
          }
        </RequiresLogin>
      </Segment>
    </CustomContainer>
  );
};
